import { simplePath } from 'ze-api-contract/utils';
import { RouteNames } from './route-names';
const user_cache = new Map();
function cache_user(path, param) {
    let { username } = param;
    if (!username) {
        return '/';
    }
    const cache_key = "".concat(path, ":").concat(username);
    const cached = user_cache.get(cache_key);
    if (cached) {
        return cached;
    }
    const url = simplePath(path, {
        username
    });
    user_cache.set(cache_key, url);
    return url;
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/user/$username"
 *   params={{ username: 'username' }}
 *   >
 *   Link text
 *   </Link>
 */ export function user_path(props) {
    return cache_user(RouteNames.USER_PROFILE, props);
}
/**
 * @deprecated Use the path directly
 * @example
 *   <Link to="/user/profile">
 *   Link text
 *   </Link>
 */ export function authenticated_user_profile_path() {
    return RouteNames.AUTHENTICATED_USER_PROFILE;
}
/**
 * @deprecated Use the path directly
 * @example
 *   <Link to="/user/settings">
 *   Link text
 *   </Link>
 */ export function user_settings_path() {
    return RouteNames.USER_PROFILE_SETTINGS;
}
/**
 * @deprecated Use the path directly
 * @example
 *   <Link to="/user/settings/emails">
 *   Link text
 *   </Link>
 */ export function user_settings_emails_path() {
    return RouteNames.USER_PROFILE_SETTINGS_EMAILS;
}
/**
 * @deprecated Use the path directly
 * @example
 *   <Link to="/user/settings/user-tokens">
 *   Link text
 *   </Link>
 */ export function user_settings_user_tokens_path() {
    return RouteNames.USER_PROFILE_SETTINGS_USER_TOKENS;
}
/**
 * @deprecated Use the path directly
 * @example
 *   <Link to="/user/settings/user-tokens/generate">
 *   Link text
 *   </Link>
 */ export function user_settings_user_token_generate_path() {
    return RouteNames.USER_PROFILE_SETTINGS_GENERATE_USER_TOKENS;
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/user/settings/user-tokens/$userToken/edit"
 *   params={{ userToken: 'token' }}
 *   >
 *   Link text
 *   </Link>
 */ export function user_settings_user_token_edit_path(userToken) {
    if (!userToken) {
        return '';
    }
    return simplePath(RouteNames.USER_PROFILE_SETTINGS_EDIT_USER_TOKEN, {
        userToken
    });
}
